export const shouldShowSuperSpeedLabel = ({
  isSuperSpeed
} = {}) => !!isSuperSpeed;